import React from 'react';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import ModuleCard from '../../../appointment/components/moduleCard/ModuleCard';
import useActivityHistory from '../../../../components/activity-history/useActivityHistory';
import ActivityHistoryList from '../../../../components/activity-history/ActivityHistoryList';

/**
 * Seção Histórico da ficha: quem cadastrou e alterou o cadastro, e quem
 * criou, alterou ou excluiu cada agendamento, e quando.
 */
const PatientActivityHistory = ({ patientId }) => {
    const { entries, labels, isLoading, error } = useActivityHistory('patient', patientId);

    return (
        <ModuleCard
            title="Histórico"
            icon={<HistoryOutlinedIcon />}
            description="Quem cadastrou e alterou o cadastro e os agendamentos, e quando"
            accent="blue"
        >
            <ActivityHistoryList
                entries={entries}
                labels={labels}
                isLoading={isLoading}
                error={error}
                showAppointment
            />
        </ModuleCard>
    );
};

export default PatientActivityHistory;
